import { render, staticRenderFns } from "./newsPage12.vue?vue&type=template&id=9a42b5be&scoped=true&"
import script from "./newsPage12.vue?vue&type=script&lang=js&"
export * from "./newsPage12.vue?vue&type=script&lang=js&"
import style0 from "./newsPage12.vue?vue&type=style&index=0&id=9a42b5be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a42b5be",
  null
  
)

export default component.exports